import React from 'react';
import { Button } from '@mui/material';

const PlayAgainButton = () => {
  return (
    <Button
      onClick={() => {
        window.location.reload();
      }}
      variant="contained"
      size="large"
    >
      Play Again
    </Button>
  );
};

export default PlayAgainButton;
